'use strict';

import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import SelectInput from './SelectInput';
import GenderVerifierLang from 'ck-core/source/verifiers/user/GenderVerifierLang';

export default class GenderInput extends React.Component {
	render() {
		return (
			<SelectInput
				{...this.props}
				choices={_.map(GenderVerifierLang.CHOICES, (value, key) => ({ key, text: value }))}
			/>
		);
	}
}

GenderInput.defaultProps = {
	placeholder: 'Select Gender',
	label: 'Gender'
};

GenderInput.propTypes = {
	label: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func,
	onValidate: PropTypes.func
};
